import { TaskState } from './models';
export var tasks = [{
        id: 'task-1',
        name: 'New EULA',
        state: TaskState.ToDo,
        description: "\n- @Mark to prepare new EULA\n- Web team to update website\n- Product team to embed EULA\n".trim()
    }, {
        id: 'task-2',
        name: 'Plan Exhibition For Trade Show',
        state: TaskState.ToDo,
        description: "\n- @Lora to book space\n- Order brochures\n- Promote event on social media\n".trim()
    }, {
        id: 'task-3',
        name: 'Prepare Marketing Collateral',
        state: TaskState.InProgress,
        description: "\n- Sales brochure\n- Infographic\n- Web content\n".trim()
    }, {
        id: 'task-4',
        name: 'Review Security Guidelines',
        state: TaskState.InProgress,
        description: "\n- @Ian to provide current documents\n- @Jane to review guidelines\n- Distribute internally\n- Define Processes\n".trim()
    }, {
        id: 'task-5',
        name: 'Implement CRM Integration',
        state: TaskState.InProgress,
        description: "\n- Prepare new microservice\n- Define responsibilities\n- Prepare JIRA user stories\n- Consult with dev team\n".trim()
    }, {
        id: 'task-6',
        name: 'Document System Architecture',
        state: TaskState.InProgress,
        description: "\n- Create architecture diagrams\n- Write architecture overview\n- Dev team to review\n".trim()
    }, {
        id: 'task-7',
        name: 'Develop iPhone App',
        state: TaskState.Complete,
        description: "\n- Create wireframes\n- Create assets\n- Define functionality\n- Hand over to dev team\n".trim()
    }, {
        id: 'task-8',
        name: 'Channel Partners Licensing',
        state: TaskState.Complete,
        description: "\n- Prepare NFR licenses\n- Document process\n- Consult with partners\n- Distribute license keys\n".trim()
    }];
export var dependencies = [{
        id: 'dep-1',
        source: 'task-2',
        target: 'task-3'
    }, {
        id: 'dep-2',
        source: 'task-6',
        target: 'task-5'
    }];
export var columns = [{
        name: 'TODO',
        state: TaskState.ToDo,
        color: '#4666E5'
    }, {
        name: 'IN PROGRESS',
        state: TaskState.InProgress,
        color: '#F9A03F'
    }, {
        name: 'COMPLETE',
        state: TaskState.Complete,
        color: '#09BC8A'
    }];
